var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CalendarBlank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6328 3.31067H4.28115C3.94007 3.31067 3.66357 3.58717 3.66357 3.92825V16.2798C3.66357 16.6209 3.94007 16.8974 4.28115 16.8974H16.6328C16.9738 16.8974 17.2503 16.6209 17.2503 16.2798V3.92825C17.2503 3.58717 16.9738 3.31067 16.6328 3.31067Z",
    stroke: "#9C9C9C",
    strokeWidth: 1.18575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.1631 2.07556V4.54588",
    stroke: "#9C9C9C",
    strokeWidth: 1.18575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.75146 2.07556V4.54588",
    stroke: "#9C9C9C",
    strokeWidth: 1.18575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.66357 7.01624H17.2503",
    stroke: "#9C9C9C",
    strokeWidth: 1.18575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bd9045394ba0e78c884f9ccbc3ffe6c3.svg";
export { ForwardRef as ReactComponent };